import http from "@/api";

export const login = (params: API.LoginCmd) => {
	return http.post<API.Response<API.SingleResult<API.AuthAccessToken>>>(`/auth/login`, params);
};

export const logout = () => {
	return http.post<API.Response<null>>(`/auth/logout`);
};

export const uploadImg = (params: any) => {
	return http.post<API.Response<API.SingleResult<API.UploadImg>>>(`/upload`, params);
};
